<template>
    <div class="content">
        <Aside :menus="menus" ></Aside>
        <div class="content-c">
         <router-view :key="$route.fullPath"/>

        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import Aside from "@/components/Aside.vue";

export default {
    name: "",
    components: {
        Aside
    },
    data() {
        return {
            menus: [
                { icon: 'myTest-1', name: "我的考试", path: "/myTest/myPaperList" },
                { icon: 'myTest-2', name: "个人自测", path: "/myTest/myZcList" },
                { icon: 'myTest-3', name: "我的错题", path: "/myTest/myCtList" },
            ]
        };
    },
    created() {
        
    },
    computed: {

    },
    methods: {

    },
};
</script>
<style lang="scss" scoped>
.content {
    padding: 20px 0;
    display: flex;

    .content-c {
        background: #FFFFFF;
        padding: 20px;
        flex: 1;
        margin-left: 20px;
    }
}
</style>